import client from "@/api/client"
import {
  conversationSchema,
  conversationsListResponseSchema,
  messageSchema,
  messagesListResponseSchema,
} from "@/api/schemas/chat"
import { baseResponseSchema } from "@/api/schemas/shared"
import { z } from "zod"

export const getConversations = async (params: {
  businessId?: string
  page?: number
  pageSize?: number
}) => {
  const response = await client.get("/api/v1/chat/conversations", { params })
  return conversationsListResponseSchema.parse(response.data)
}

export const getMessages = async (
  conversationId: string,
  params?: { page?: number; pageSize?: number; before?: string },
) => {
  const response = await client.get(
    `/api/v1/chat/conversations/${conversationId}/messages`,
    { params },
  )
  return messagesListResponseSchema.parse(response.data)
}

export const sendMessage = async (conversationId: string, content: string) => {
  const response = await client.post(
    `/api/v1/chat/conversations/${conversationId}/messages`,
    { content },
  )
  return baseResponseSchema
    .extend({
      data: z
        .object({
          message: messageSchema.optional(),
          conversation: conversationSchema.optional(),
        })
        .optional(),
    })
    .parse(response.data)
}

export const markConversationRead = async (conversationId: string) => {
  const response = await client.patch(
    `/api/v1/chat/conversations/${conversationId}/read`,
  )
  return baseResponseSchema.parse(response.data)
}

export const createConversation = async (businessId: string) => {
  const response = await client.post("/api/v1/chat/conversations", {
    businessId,
  })
  return baseResponseSchema
    .extend({ data: conversationSchema.optional() })
    .parse(response.data)
}
